import { FC, memo } from 'react'
import { SvgComponent } from '@platform/ui'
import styles from './ShowMoreBtn.module.scss'

type ShowMoreBtnProps = {
  onClick: VoidFunction
  collapsed: boolean
  collapsedText: string
  uncollapsedText: string
}
export const ShowMoreBtn: FC<ShowMoreBtnProps> = memo(({ onClick, collapsed, collapsedText, uncollapsedText }) => {
  return (
    <button className={styles.btn} onClick={onClick}>
      {collapsed ? collapsedText : uncollapsedText}
      {collapsed ? (
        <div className={styles.icon}>
          <SvgComponent name="ArrowDownMediumStroke" size="sm" />
        </div>
      ) : (
        <div className={styles.icon}>
          <SvgComponent name="ArrowUpMediumStroke" size="sm" />
        </div>
      )}
    </button>
  )
})
